import React , {Component,Fragment} from 'react';
import Roll from 'react-reveal/Roll';
import Fade from 'react-reveal/Fade';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import ReactResizeDetector from 'react-resize-detector';
import ReactInterval from 'react-interval';

export default class Project extends Component{
    constructor(props){
        super(props);
        this.state = {
            picture : 0,
            projects : [
                {
                    title : "Bandara",
                    jobs : [
                        "Bandara International Soekarno Hatta (t3)",
                        "Bandara Intl.Sultan Syarif Kasim II Pekanbaru",
                        "Terminal 2 Bandara soekarno Hatta",
                    ],
                    image : "/images/soetta.jpg",
                    images : [
                        "/images/bandara-1.jpg",
                        "/images/bandara-2.jpg",
                        "/images/bandara-3.jpg"
                    ]
                },
                {
                    title : "Hotel Apartemen & Perumahan",
                    jobs : [
                        "Ciputra International 3,4,5",
                        "Wisma Atlet Tower 5,6,7",
                        "Hotel Grandhika Semarang",
                        "The Reiz Condo",

                        // V pindahin nanti

                 
                    ],
                    image : "/images/ciputra.jpg",
                    images : [
                        "/images/hotel-1.jpg",
                        "/images/hotel-2.jpg",
                        "/images/hotel-3.jpg"
                    ]
                },
                {
                    title : "Kantor & Sarana Pemerintahan",
                    jobs : [
                        "GBK Senayan",
                        "DPRD Pekan Baru",
                        "Mabes Polri Sisi Barat",
                        "LRT Koridor 1 Phase 1"
                    ],
                    image : "/images/wisma-atlet.jpg",
                    images : [
                        "/images/pemerintah-1.jpg",
                        "/images/pemerintah-2.jpg",
                        "/images/pemerintah-3.jpg"
                    ]
                },
                {
                    title : "Pabrik",
                    jobs : [
                        "Sarulla Medan",
                        "Sari Roti Cikande",
                        "PT. Indonesia Epson Industry",
                        "Indarung Semen Padang" 
                    ],
                    image : "/images/royal-dental.jpg",
                    images : [
                        "/images/pabrik-1.jpg",
                        "/images/pabrik-2.jpg",
                        "/images/pabrik-3.jpg"
                    ]
                },
                {
                    title : "Perkantoran",
                    jobs : [
                        "Gedung Mandiri Type A Kawasan Wijaya Kusuma",
                        "Citra Tower Kemayoran",
                        "Cikini Office Tower",
                        "Daswin Tower"
                    ],
                    image : "/images/transmart.jpg",
                    images : [
                        "/images/perkantoran-1.jpg",
                        "/images/perkantoran-2.jpg",
                        "/images/perkantoran-3.jpg"
                    ]
                },
                {
                    title : "Rumah Sakit",
                    jobs : [
                        "RS Columbia Asia Medan",
                        "RSUD Koja",
                        "RS Pelabuhan Palembang",
                        "RS. Royal Taruma"
                    ],
                    image : "/images/untar.jpg",
                    images : [
                        "/images/rs-1.jpg",
                        "/images/rs-2.jpg",
                        "/images/rs-3.jpg"
                    ]
                },
                {
                    title : "Shopping Mall & Trade Center",
                    jobs : [
                        "Sadira Plaza & Hotel Tangram",
                        "Bellevue Mall Cinere",
                        "Transmart Lampung",
                        "Transpark Bintaro"
                    ],
                    image : "/images/grandhika.jpg",
                    images : [
                        "/images/mall-1.jpg",
                        "/images/mall-2.jpg",
                        "/images/mall-3.jpg"
                    ]
                },
                {
                    title : "Universitas & Sekolah",
                    jobs : [
                        "Kampus II Universitas Tarumanagara (ekonomi)",
                        "Universitas Negeri Semarang (UNNES)",
                        "Universitas Lambung Mangkurat" 
                    ],
                    image : "/images/epson.jpg",
                    images : [
                        "/images/uni-1.jpg",
                        "/images/uni-2.jpg",
                        "/images/uni-3.jpg"
                    ]
                },
            ]
            
        };
        this.handleWidth = this.handleWidth.bind(this);
        this.handleInterval = this.handleInterval.bind(this);

    }
    handleInterval(){  
        let picture = this.state.picture;
        picture = picture == 2? 0: picture + 1;
        this.setState({
            picture : picture
        });
    }

    handleWidth(){
        this.setState({width: window.innerWidth});
    }

    render(){
        return(
            <Fragment>
                <ReactInterval timeout={3000} enabled={true} callback={() => this.handleInterval()} />
                <ReactResizeDetector handleWidth onResize={this.handleWidth} />
                <div className="container mt-5 mb-5">
                    <h1 className="mb-5">Noteable MEP Projects</h1>
                    {this.state.projects.map((project) => {
                            let i = Math.floor((Math.random() * 5) + 1);
                            return(
                                <div className="row w-100 p-2 mb-5 mx-0">
                                    <div className="col-sm-7">
                                       <Fade>
                                            <h2>{project.title}</h2>
                                            <ul>
                                                {project.jobs.map((job) => {
                                                    return(
                                                        <li>
                                                            <h4>
                                                                {job}
                                                            </h4>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                       </Fade>
                                    </div>
                                    
                                    <div className="col-5">
                                        <div width="400px" className={`shape-${i} width-400 bg-blue-secondary`}>
                                            <div>
                                                <img src={project.images[this.state.picture]} width="400px" height="400px" className={`shape-${i} cover`}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                    })}
                    <h1 className="mb-5">Other Projects</h1>
                    <h2>Kantor & Sarana Pemerintahan</h2>
                    <div className="row w-100 p-2 mb-5 mx-0">
                        <div className="col-sm">
                            <Fade>
                                <ul>
                                    <li>
                                        <h4>
                                            PLBN Aruk, Tahap 2 Kalimantan Barat
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Puspemkot Tangsel 
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Puslabor Jayapura
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            LRT Koridor 1 Jakarta
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                             Sespimma Polri Lembang
                                        </h4>
                                    </li>
                                </ul>
                              
                            </Fade>

                        </div>
                        <div className="col-sm">
                           <Fade>
                           <ul>
                                <li>
                                    <h4>
                                        EPCC LRT Jabodetabek MEP - TPSS INDONESIA
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Puslabor Pekanbaru
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Yodya Tower
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        KOMINFO Bekasi
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Puspemkot Tangsel 
                                    </h4>
                                </li>
                           </ul>
                           </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                              <ul>
                                <li>
                                    <h4>
                                        Keong Mas
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        BPR Palu & BPR Toli Toli
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        PLBN Aruk, Kalimantan Barat
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Kawasan Berikat Nusantara
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Departemen Pertahanan
                                    </h4>
                                </li>
                            </ul>
                            </Fade>
                        </div>
                        <div className="col-sm">
                          <Fade>
                            <ul>
                                <li>
                                    <h4>
                                        Kantor Bersama Sijunjung
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        DISPENDA Kota bekasi 
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Gedung Iradiator Badan Tenaga Nuklir Nasional
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                         BPOM Semarang
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        BPL Belawan
                                    </h4>
                                </li>

                            </ul>
                        </Fade>
                        </div>
                    </div>                    
                    <div className="row w-100 p-2 mb-5 mx-0">
                        <div className="col-sm">
                        <Fade>
                                <h2>Hotel Apartemen & Perumahan</h2>
                                <ul>
                                    <li>
                                        <h4>
                                            Beverly hills Jababeka
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Swiss Belhotel extention 
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Hotel Poso
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Cinere Resort Apartemen
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Rumah SusunTingkat Tinggi Pasar Jumat
                                        </h4>
                                    </li>
                                </ul>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <h2 className="pb-sm-4">Pabrik</h2>
                                <ul>
                                    <li>
                                        <h4>
                                            Aerofood Kualanamu Medan
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Maxi II
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Internusa Food
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Lapis Bogor
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Dirgantara
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Hempel Indonesia
                                        </h4>
                                    </li>
                                </ul>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <h2 className="pb-sm-4">Perkantoran</h2>
                                <ul>
                                    <li>
                                        <h4>
                                            Persekutuan Gereja - Gereja Di Indonesia
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Kantor Pemasaran Cibubur (Jakarta Living Star)
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Bank Sumut
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Gedung Kantor Pusat Mobilkom
                                        </h4>
                                    </li>
                                   
                                </ul>
                            </Fade>

                        </div>
                    </div>       
                    <div className="row w-100 p-2 mb-5 mx-0">
                        <div className="col-sm">
                            <Fade>
                                <h2>Universitas & Sekolah</h2>
                                <ul>
                                    <li>
                                        <h4>
                                            Sekolah PAHOA
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Rehap Design & Build Rehab Sekolahan
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Kampus 1 Universitas Tarumanagara
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Rehab Total Gd Sekolah Paket II & V
                                        </h4>
                                    </li>
                                </ul>
                            </Fade>
                        </div>
                        <div className="col">
                            <Fade>
                                <h2>Rumah Sakit</h2>
                                <ul>
                                    <li>
                                        <h4>
                                            RS. St. Carolus
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            RSSN bukit tinggi
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            Gedung RSUD Bekasi
                                        </h4>
                                    </li>
                                 
                                    <li>
                                        <h4>
                                            RS Pertamina Tarakan
                                        </h4>
                                    </li>
                                    <li>
                                        <h4>
                                            RS Pelabuhan Palembang
                                        </h4>
                                    </li>

                                </ul>
                            </Fade>
                        </div>
                        <div className="col">
                          <Fade>
                            <ul className="pt-sm-5">
                                <li>
                                    <h4>
                                        RSUP H. Adam Malik Medan
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        RS Royal Dental
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        RSJ Mapan Pekanbaru
                                    </h4>
                                </li>
                                <li>
                                    <h4>
                                        Carolus II
                                    </h4>
                                </li>
                            </ul>
                            </Fade>
                        </div>
                    </div>       
                </div>
            </Fragment>
        );
    }
}


  